
import { Vue, Component } from 'vue-property-decorator';
import {
  Tag,
  Dropdown,
  DropdownItem,
  DropdownMenu,
} from 'element-ui';
import Scroll from 'better-scroll';
import { State, Action } from 'vuex-class';
import { IAPPSTATE, IOpenTag } from '@/store/state.d';

@Component({
  components: {
    Tag,
    Dropdown,
    DropdownItem,
    DropdownMenu,
  },
})
export default class TNav extends Vue {
  @State app!: IAPPSTATE

  @Action('app/closePage') closePage!: Function

  $refs!: {
    nav: HTMLElement,
  }

  /**
   * @author Terry
   * @description 标签切换
   * @param { Object } 当前标签值
   */
  tagChange(value: { path: string, params: any }) {
    if (value.path === this.$route.path) return;
    this.$router.push({
      name: value.path,
      params: value.params,
    });
  }

  /**
   * @author Terry
   * @description 关闭标签
   * @param { Object } 当前标签值
   */
  tagClose(value: { path: string }) {
    this.closePage({ type: '0', path: value.path }).then((tag: IOpenTag) => {
      if (tag.path !== value.path) {
        this.$router.push({ name: tag.path, params: tag.params });
      }
    });
  }

  /**
   * @author Terry
   * @description 关闭标签
   * @param { Object } 当前关闭方式
   */
  tagCloseWays(type: string) {
    this.closePage({ type, path: this.$route.name }).then((tag: IOpenTag) => {
      if (tag.path !== this.$route.path) {
        this.$router.push({ name: tag.path, params: tag.params });
      }
    });
  }

  mounted() {
    /* eslint-disable no-new */
    new Scroll(this.$refs.nav, {
      scrollX: true,
      mouseWheel: {
        speed: 20,
        invert: false,
        easeTime: 300,
      },
    });
  }
}
